import React from 'react';
import './distance-display.css';

const DistanceDisplay = ({ distance, location }) => {
  return (
    <div className="distance-display">
      <h4>Geographic Proximity</h4>
      <div className="distance-info">
        <span className="icon">📍</span>
        <span className="distance-value">{distance.toFixed(2)} miles apart</span>
      </div>
      {location && <p className="location-name">in {location}</p>}
    </div>
  );
};

export default DistanceDisplay;
